@if(package()) {
<h1 class="text-2xl">
  <strong>Forfait</strong> - <small>{{ package()?.name }}</small>
  <button matIconButton matTooltip="Modifier ce forfait" (click)="updatePackage()"><mat-icon>edit</mat-icon></button>
  <button matIconButton matTooltip="Supprimer ce forfait" (click)="deletePackage()"><mat-icon>delete</mat-icon></button>
</h1>

<p>
  <strong>Type</strong>: {{ package()?.type == 'monthly' ? 'Mensuel' : 'Illimité' }}<br>

  @if (package()?.type == 'monthly') {
  <strong>Limite de consommation</strong>: {{ package()?.limit }} secondes<br>
  }

  <strong>Description</strong>:<br>
  <span style="white-space: pre-line;">{{ package()?.description }}</span>
</p>

<mat-accordion class="m-4">
  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>Pays inclus</mat-panel-title>
    </mat-expansion-panel-header>

    <p>
      <button matButton (click)="createPackageArea()"><mat-icon>add</mat-icon> Ajouter une entrée</button>
    </p>

    <br>

    <ag-grid-angular
        style="width: 100%; height: 400px;"
        [rowData]="package()?.areas"
        [columnDefs]="areaColumns"
        [autoSizeStrategy]="autoSizeStrategy"
        [localeText]="localeText"
        [getRowId]="getRowId"
        (gridReady)="onAreaGridReady($event)"
    />
  </mat-expansion-panel>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>Zones incluses</mat-panel-title>
    </mat-expansion-panel-header>
    
    <p>
      <button matButton (click)="createPackageZone()"><mat-icon>add</mat-icon> Ajouter une entrée</button>
    </p>

    <br>

    <ag-grid-angular
        style="width: 100%; height: 400px"
        [rowData]="package()?.zones"
        [columnDefs]="zoneColumns"
        [autoSizeStrategy]="autoSizeStrategy"
        [localeText]="localeText"
        [getRowId]="getRowId"
        (gridReady)="onZoneGridReady($event)"
    />
  </mat-expansion-panel>
</mat-accordion>
}